import app from 'flarum/forum/app';
import UserPage from "flarum/forum/components/UserPage";
import FlagList from 'flarum/flags/components/FlagList';

export default class FlagUserPage extends UserPage {
  oninit(vnode) {
    super.oninit(vnode);
    this.loadUser(m.route.param('username'));
    app.flags.load();
  }

  content() {
    return (
      <div className="FlagsPage">
        <FlagList state={app.flags}></FlagList>
      </div>
    );
  };
}
